import { render, staticRenderFns } from "./SmsManagement.vue?vue&type=template&id=dbaa15ac&scoped=true&"
import script from "./SmsManagement.vue?vue&type=script&lang=js&"
export * from "./SmsManagement.vue?vue&type=script&lang=js&"
import style0 from "./SmsManagement.vue?vue&type=style&index=0&id=dbaa15ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaa15ac",
  null
  
)

export default component.exports